// @ts-nocheck
import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import styles from "./feedback.module.css";
import PropTypes from "prop-types";
import { useMemo } from "react";
import { getCssVariableHandler } from "../../../../utils/styles/getCssVariables";
import theme from "../../../../theme";
import RatingComponent from "../../../../components/Custom/CustomRating";
import { CustomTextFiled } from "../../../../components/Custom/Input";
import PositionList from "./PositionText";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 4,
  width: "50rem",
  maxWidth: "90vw",
  height: "auto",
  maxHeight: "80vh",
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: 2,
  overflowY: "auto",
  "@media (max-width: 600px)": {
    width: "80vw",
    maxHeight: "80vh",
  },
};

export default function FeedbackModal({
  open,
  handleClose,
  userData,
  userRole: role,
  getTimeString,
}) {
  // NOTE: the user data will have array of user data
  // In case of multiple user, we'll send those data of arrays
  const loading = false;

  const getNames = useMemo(() => {
    const positions = userData?.flatMap((user) =>
      user?.positionNames?.map((pos) => pos),
    );
    const users = userData?.map(
      (user) => user?.contractorName ?? user?.name ?? " ",
    );
    const restNames = users?.length > 2 ? users?.length - 2 : 0;
    const restPositions = positions?.length > 2 ? positions?.length - 2 : 0;
    return {
      users,
      positions,
      isMore: userData?.length > 2 ? true : false,
      isPositionsMore: positions?.length > 2 ? true : false,
      restNames,
      restPositions,
    };
  }, [userData]);

  const questionsList = useMemo(() => {
    return [
      "Did the contractor arrive on time and follow the schedule?",
      "How would you rate the quality of their work?",
      "Did they maintain a professional attitude?",
      "Was their communication clear and responsive?",
      "How satisfied were you with their performance?",
      "Would you hire this contractor again?",
    ];
  }, []);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Typography variant="h4" color="primary" textAlign="center">
          Share Feedback
        </Typography>

        {/* NOTE: contractor name and positions details */}
        {/* NOTE: in case the name or positions more than 2 show tooltip */}
        <Box
          sx={{
            borderColor: `${getCssVariableHandler({
              variableName: "--primary-pink-hex",
            })} !important`,
          }}
          className={styles["details-container"]}
        >
          <Box className={styles["flex-box"]}>
            <Typography
              className={styles["user-name"]}
              sx={{ color: theme.palette.green.main, marginRight: "0.5rem" }}
            >
              {role} Name:
            </Typography>
            <Typography className={styles["user-name"]}>
              {getNames?.isMore
                ? getNames?.users?.slice(0, 1)?.join(", ")
                : getNames?.users?.join(", ")}

              {getNames?.isMore && (
                <Tooltip
                  title={
                    <Box
                      className={styles["tooltip-container"]}
                      sx={{
                        borderColor: getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        }),
                      }}
                    >
                      {getNames?.users?.slice(2)?.map((user, i) => (
                        <Typography key={i}>{user}</Typography>
                      ))}
                    </Box>
                  }
                >
                  <Typography className={styles["more-button"]}>
                    {getNames?.restNames} more users
                  </Typography>
                </Tooltip>
              )}
            </Typography>
          </Box>

          <Box className={styles["flex-box"]}>
            <Typography
              className={styles["user-name"]}
              sx={{ color: theme.palette.green.main, marginRight: "0.5rem" }}
            >
              Position Name:{" "}
            </Typography>
            <PositionList
              positions={getNames?.positions}
              getTimeString={getTimeString}
            />
          </Box>
        </Box>

        {/* NOTE: Questions and stars */}
        <Box
          className={styles["response-wrapper"]}
          sx={{
            borderColor: `${getCssVariableHandler({
              variableName: "--primary-pink-hex",
            })} !important`,
          }}
        >
          <Box className={styles["question-wrapper"]}>
            {questionsList?.map((question, i) => (
              <Box className={styles["question-container"]} key={i}>
                <Typography>{question}</Typography>
                <RatingComponent name={`${i}-rating`} size="large" />
              </Box>
            ))}
          </Box>

          {/* NOTE: additional comments */}

          <Typography sx={{ width: "100%", textAlign: "left", mt: 2 }}>
            Additional Comments
          </Typography>
          <CustomTextFiled
            fullWidth
            placeholder="Additional comments (max 200 characters)"
            name="additionalComments"
            multiline={true}
            rows={5}
            sx={{
              color: "white",
              border: `1px solid`,
              borderColor: "white",
              height: "135px !important",
              borderRadius: "10px",
              "& .MuiOutlinedInput-root": {
                padding: "0.25rem !important",
              },
              "& fieldset": {
                border: "none !important",
                padding: "0 16px",
                boxShadow: "0px 0px 30px 0px #FFFFFF1A",
                fontSize: "16px",
              },
              "& textarea": {
                overflow: "hidden",
                resize: "none",
                padding: "5px 10px 0 10px",
                overflowY: "auto",
              },
            }}
          />
        </Box>

        {/* NOTE: button to submit / close */}

        <Box
          className="bottom-btn-box"
          sx={{ width: "100%", marginTop: "auto" }}
        >
          <Button
            className="btn-black"
            onClick={() => {
              handleClose();
            }}
          >
            <Typography className="btn-text">CLOSE</Typography>
          </Button>
          <Button
            sx={
              {
                // cursor: newSessionLoading ? "not-allowed" : "pointer",
              }
            }
            className="btn-pink"
            onClick={() => {}}
          >
            {loading ? (
              <CircularProgress />
            ) : (
              <Typography className="btn-text">Submit</Typography>
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

FeedbackModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  userRole: PropTypes.string,
  userData: PropTypes.array,
  getTimeString: PropTypes.func,
};